import { Badge } from "@/components/ui/badge";
import { Tooltip } from "@/components/ui/misc";
import { sentByCadenceText } from "@/lib/cadence";
import type { MessageCadence } from "@/lib/types";

/**
 * The mark on a text a cadence sent (ADR-135 in platform): "Cadence", on the record's timeline, so a
 * supervisor and up does not read it as a person's or wonder who "Automated" was. A rep is not shown
 * it (ACL-591); a conversation and the record's SMS tab name the cadence under the time's pointer
 * instead (`messageDetail`). Under the pointer it names the cadence and the step. core-api says which
 * texts they are (`sent_by_cadence`); the console works nothing out.
 */
export function CadenceBadge({ cadence }: { cadence: MessageCadence }) {
  return (
    <Tooltip content={sentByCadenceText(cadence)}>
      <Badge size="sm" tone="accent" tabIndex={0}>
        Cadence
      </Badge>
    </Tooltip>
  );
}
